<template>
  <div class="outer">
    <div class="loader-overlay" :class="{'shown': isOverlayShown}" aria-hidden>
      <div class="loader-background-image"></div>
    </div>
      <news-view
        :nids="sortedNids"
        :orgNids="nids"
        :nid="activeNID"
        ref="newsView"
        v-model="index"
        :shareOpts="shareOpts"
        :newsHome="newsHome"
        @newsViewLoaded="newsViewLoaded"
        @newsViewReady="newsViewReady"
        @start-moving="slideMoving = true"
        @end-moving="slideMoving = false"
        @update-first-nid="(nid) => firstNID = nid"
        >
        <template v-slot:close-btn>
          <div v-show="showCloseButton" class="close-btn" @click="closeNewsView()" :class="{'slide-moving': slideMoving}">
            <close-icon></close-icon>
          </div>
        </template>
        <template v-slot:close-btn-overlay>
          <div class="close-news-view-helper" @click="closeNewsView()"></div>
        </template>
      </news-view>
      <toggle-share-buttons
         class="toggle-share-wrapper hidden-sm-up techCityNewsView__shareButtons"
         v-if="mounted && shareUrl"
         :shareUrl="shareUrl"
         mode="Tech City News"
         :title="seoTitle"
         @share-count-fetched="false"
         @share-hover="shareHover"
         :showCount="false"
         :showNumberAnyway="false"
         :bypassUserInteraction="true"
         iconDesktop="down"></toggle-share-buttons>
    </div>
</template>

<script>
  import get from 'lodash/get'
  import uniq from 'lodash/uniq'
  import compact from 'lodash/compact'
  import head from 'lodash/head'

  import { isDesktop, seoTitleFormatter, localStorageAvailable } from 'mixins/utilities'
  import storage from 'local-storage-fallback'
  import GTMManager from 'mixins/gtm-manager'
  import mounted from 'components/mixins/mounted'
  import closeIcon from 'static/svg/icon_close.svg'

  import {
    mapGetters,
    mapMutations,
    mapState,
  } from 'vuex'

  export default {
    name: 'tech-city-news',
    mixins: [mounted],
    components: {
      NewsView: () => import('components/tech-city/news-view/NewsView.vue'),
      closeIcon,
      ToggleShareButtons: () => import('components/widgets/ToggleShareButtons.vue'),
    },
    props: {
      nids: {
        type: Array,
        required: true,
      },
      newsHome: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        index: 0,
        isShowArrow: true,
        shareBarActive: 'hide',
        shareBarWaitForActive: false,
        isShowPageShareButton: false,
        slideMoving: false,
        isInited: false,
        showCloseButton: false,
        isOverlayShown: 'closed',
        firstNID: false,
      }
    },
    created() {
      this.setTechCityNewsViewIsShown(true)
    },
    methods: {
      ...mapGetters(['requestDomain']),
      ...mapMutations(['setActiveNID', 'setTechCityNewsViewIsShown']),
      toggleShareBarActive (value) {
        if (this.shareBarWaitForActive && this.shareBarActive === 'reset') {
          return
        }
        this.shareBarActive = (value || get(this, '$refs.shareButtons.nativeShare')) ? 'active' : 'hide'
      },
      shareHover(isShow) {
        if (isShow && isDesktop()) {
          GTMManager.pushTracker({
            category: 'Hover',
            action: 'China Tech City News View/Share/Hover',
          })
        }
      },
      swiperInit() {
        this.$refs.newsView.swiperInit()
      },
      newsViewLoaded() {
        this.$emit('newsViewLoaded')
        this.updateUsersNewsBiteReadingList()
        this.isInited = true
      },
      newsViewReady() {
        this.$emit('newsViewReady')
        this.showCloseButton = true
      },
      closeNewsView() {
        this.$refs.newsView.close()
        setTimeout(() => {
          this.isOverlayShown = false
          setTimeout(() => {
            this.$emit('newsViewButtonOnClick', false)
          }, 200)
        }, 300)
      },
      updateUsersNewsBiteReadingList() {
        if (localStorageAvailable() && this.activeNID) {
          const techCityNewsUserHasRead = storage.getItem('tech-city-news-user-has-read') || ''
          storage.setItem('tech-city-news-user-has-read', compact(uniq([...techCityNewsUserHasRead.split(','), this.activeNID])).join(','))
          this.$emit('usersNewsBiteReadingListUpdated')
        }
      },
    },
    computed: {
      ...mapState(['activeNID', 'isBot']),
      activeNid() {
        return get(this, `sortedNids[${this.index}]`, false)
      },
      shareUrl() {
        const route = get(this, '$route.fullPath', '')
        if (route) {
          return `${this.requestDomain()}${route}`
        }
        return false
      },
      seoTitle() {
        const node = this.$store.getters.node(this.activeNID)
        const pageType = 'tech-city-news'
        return seoTitleFormatter({pageType, node})
      },
      shareOpts() {
        return {
          shareUrl: this.shareUrl || '',
          seoTitle: this.seoTitle || '',
        }
      },
      sortedNids() {
        return this.isBot ? [head(compact(uniq([this.firstNID, ...this.nids])))] : compact(uniq([this.firstNID, ...this.nids]))
      },
    },
    mounted() {
      this.firstNID = this.activeNID
      this.$nextTick(function () {
        setTimeout(() => {
          this.isOverlayShown = true
        }, 200)
      })
    },
    watch: {
      index() {
        this.setActiveNID(this.activeNid)
        this.updateUsersNewsBiteReadingList()
      },
    },
  }
</script>
<style lang="scss" scoped>
  .close-btn {
    width: rem-calc(48);
    height: rem-calc(48);
    background: $black;
    position: absolute;
    top: 0;
    fill: $white;
    padding: rem-calc(15);
    border-radius: rem-calc(60);
    overflow: hidden;
    cursor: pointer;
    z-index: 1;
    left: 50%;
    transform: translateX(calc(40vw + 15px));
    transition: 500ms;
    &.slide-moving {
      opacity: .2;
    }

    @include respond-to('mobile') {
      fill: $black;
      background-color: transparent;
      top: rem-calc(15);
      right: 0;
      left: initial;
      transform: none;
    }

    @include respond-to("hd") {
      right: initial;
      left: 50%;
      transform: translateX(rem-calc(640));
    }

    @include respond-to("largedesktop") {
      right: initial;
      left: 50%;
      transform: translateX(rem-calc(615));
    }
  }
  .techCityNewsView {
    &__shareButtons {
      position: fixed;
      top: 100%;
      z-index: 100;
      transition: transform 0ms;
      right: rem-calc(10);
      margin-top: rem-calc(-67);

      &.active {
        transition: transform 400ms;
        transform: translateY(rem-calc(-50));
        &.bottom-buffer {
          transform: translateY(rem-calc(-90));
        }
      }

      &.hide {
        transition: transform 400ms;
        transform: translateY(rem-calc(50));
      }

      &:not(.share-button-native-container) {
        &.inCard {
          transform: translateY(rem-calc(50));
        }
      }

      &.share-button-native-container {
        right: rem-calc(16);
        bottom: rem-calc(20);
        transform: translateY(0);
        left: inherit;
        top: inherit;
        &.hide {
          transform: translateY(rem-calc(85)) !important;
        }
        &.reset {
          transition: transform 400ms;
        }
        &.inCard {
          transition: transform 0ms;
          transform: translateY(rem-calc(85)) !important;
          &.active {
            transition: transform 400ms;
          }
        }
      }
      &.no-animation {
        transition: transform 0ms !important;
      }
    }
  }
  /deep/ {
    .toggle-share-wrapper.toggle-share-wrapper.with-count, .toggle-share-wrapper.toggle-share-wrapper {
      z-index: 2000;
    }
  }

  // loader
  @keyframes loaderLoaded {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  .loader-overlay {
    z-index: 4;
    opacity: 0;
    transition: opacity 300ms ease;
    &.closing {
      opacity: 0;
    }
    &.shown {
      opacity: 1;
    }
  }
  .loader-background-image {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: cover;
    opacity: 1;
    @include respond-to("mobile") {
      background-image: url(/static/images/techcity_loading_mobile.jpg);
    }
    @include respond-to("desktop") {
      background-image: url(/static/images/techcity_loading.jpg);
    }
    @include respond-to("desktop_wide") {
      background-image: url(/static/images/techcity_loading_hd.jpg);
    }
  }
</style>



// WEBPACK FOOTER //
// components/tech-city/TechCityNews.vue